<template>
	<main>
		<banner :title="getText('ventspils-title')"/>
		<section class="bg-gray-700">
			<div class="container mx-auto px-4 pb-16 md:pb-48">
				<div class="flex flex-wrap w-full">
					<div class="text-left pt-12 w-full">
						<div class="block mb-4">
							<h2 class="text-white font-semibold text-3xl">{{ getText('p-name-2') }}</h2>
						</div>
						<div class="flex flex-wrap">
							<div class="w-full md:w-6/12">
								<p class="text-white font-semibold mb-4">{{ getText('p-location-2') }}</p>

								<p class="text-white font-semibold mb-4">{{ getText('about-duties') }}: {{ getText('w-duties-2') }}</p>

								<p class="text-white font-semibold mb-4">{{ getText('client') }}: {{ getText('p-client-2')}}</p>

								<div class="text-white font-semibold">
									<p class="pb-4">{{ getText('description') }}:</p>
									<p class="pb-4">{{ getText('ventspils-description-1') }}</p>
									<p class="pb-4">{{ getText('ventspils-description-2') }}</p>
									<p class="pb-4">{{ getText('ventspils-description-3') }}</p>
									<p class="pb-4">{{ getText('ventspils-description-4') }}</p>
									<p class="pb-4">{{ getText('ventspils-description-5') }}</p>
									<p class="pb-4">{{ getText('ventspils-description-6') }}</p>
									<p class="pb-4">{{ getText('ventspils-description-7') }}</p>
								</div>

								<div class="text-white font-semibold">
									<p class="pb-4">{{ getText('collab') }}:</p>
									<ul>
										<li v-for="partner in partners" :key="partner">
											<i class="fas fa-caret-up pr-4 pl-4"></i>
											<span>{{ getText(partner) }}</span>
										</li>
									</ul>
								</div>

								<div class="text-white font-semibold">
									<p class="text-white font-semibold mb-4 mt-4">{{ getText('object-data') }}</p>
									<ul>
										<li>
											<i class="fas fa-caret-up pr-4 pl-4"></i>
											<span>{{ getText('object-parcel-area') }}: 31,163 m²</span>
										</li>
										<li>
											<i class="fas fa-caret-up pr-4 pl-4"></i>
											<span>{{ getText('object-total-area') }}: 6,883 m²</span>
										</li>
										<li>
											<i class="fas fa-caret-up pr-4 pl-4"></i>
											<span>{{ getText('object-construction-area') }}: 5,541 m²</span>
										</li>
										<li>
											<i class="fas fa-caret-up pr-4 pl-4"></i>
											<span>{{ getText('object-volume') }}: 53,000 m³</span>
										</li>
										<li>
											<i class="fas fa-caret-up pr-4 pl-4"></i>
											<span>{{ getText('object-road-field-area') }}: 12,432 m²</span>
										</li>
										<li>
											<i class="fas fa-caret-up pr-4 pl-4"></i>
											<span>{{ getText('object-greenery-area') }}: 13,361 m²</span>
										</li>
									</ul>
								</div>

								<div class="pt-4">
								<span class="text-white font-semibold">
									{{ getText('additional-information') }}:
								</span>
									<a class="underline text-white font-semibold" href="https://www.koncertzalelatvija.lv">
										KoncertzaleLatvija.lv
									</a>
								</div>
							</div>
							<div class="w-full md:w-6/12 md:pl-16 pt-4 md:pt-12">
								<slider :images="slidesVentspils"></slider>
								<p class="text-white pt-2">Foto: A.Mežule</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</main>
</template>

<script>
	import {VENTSPILS_PARTNERS} from '../../data/projectPartners'
	import {mapGetters} from "vuex";
	import Slider from '../../components/Slider.vue';
	import Banner from "../Banner";

	export default {
		name: "Ventspils",
		components: {
			Banner,
			Slider,
		},
		data() {
			return {
				partners: VENTSPILS_PARTNERS,
				slidesVentspils: [
					'/images/ventspils/ventspils-1.jpg',
					'/images/ventspils/ventspils-2.jpg',
					'/images/ventspils/ventspils-3.jpg',
					'/images/ventspils/ventspils-4.jpg',
					'/images/ventspils/ventspils-6.jpg',
					'/images/ventspils/ventspils-7.jpg',
					'/images/ventspils/ventspils-8.jpg',
				]
			}
		},
		computed: {
			...mapGetters(['getText'])
		},
	}
</script>